<template>
  <div v-if="articleInfo" class="widget-article-card-wrapper">
    <ArticleItem :item="articleInfo" link-target="_blank"></ArticleItem>
  </div>
</template>

<script>
import ArticleItem from '@/components/article/ArticleItem'
import { THIRD_API } from '@/global/config'

export default {
  components: {
    ArticleItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      articleInfo: null
    }
  },
  created() {
    this.getArticleInfo()
  },
  methods: {
    async getArticleInfo() {
      const {
        source: { id = '', alias }
      } = this.data
      if (!id) {
        return
      }
      const { data = [] } = await this.$http.get(
        THIRD_API.alkArticleDetail.link,
        {
          params: { id }
        }
      )
      if (alias) {
        data.title = alias
      }
      this.articleInfo = data
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-article-card-wrapper {
  width: 278px;
  margin: 30px auto 0;
}
</style>
